package com.swetdot.swetgram.ui.chat

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.unit.sp
import com.swetdot.swetgram.ui.design.Radius
import com.swetdot.swetgram.ui.design.Space
import com.swetdot.swetgram.ui.design.SwetPressFeedback
import com.swetdot.swetgram.ui.design.SwetIcon
import com.swetdot.swetgram.ui.design.SwetIconButton
import com.swetdot.swetgram.ui.design.SwetIcons
import com.swetdot.swetgram.ui.design.swetPressable
import com.swetdot.swetgram.ui.theme.SwetgramThemeTokens
import org.jetbrains.compose.resources.stringResource
import swetgram.shared.generated.resources.Res
import swetgram.shared.generated.resources.chat_reactions_more

val REACTION_OPTIONS = listOf("❤️", "👀", "😢", "🎉", "🔥", "👍")
internal val MORE_REACTION_OPTIONS = listOf("😂", "😮", "😡", "🤔", "🙏", "👎")

/**
 * A horizontal picker for message reactions.
 */
@Composable
fun ReactionPicker(
    onEmojiSelected: (String) -> Unit,
    modifier: Modifier = Modifier,
) {
    val colors = SwetgramThemeTokens.colors
    var expanded by remember { mutableStateOf(false) }

    Column(
        modifier = modifier
            .clip(RoundedCornerShape(Radius.xl))
            .background(colors.card)
            .padding(horizontal = Space.one, vertical = Space.half),
    ) {
        Row(
            horizontalArrangement = Arrangement.spacedBy(Space.half),
            verticalAlignment = Alignment.CenterVertically,
        ) {
            REACTION_OPTIONS.forEach { emoji -> ReactionEmoji(emoji, onEmojiSelected) }
            SwetIconButton(
                contentDescription = stringResource(Res.string.chat_reactions_more),
                onClick = { expanded = !expanded },
            ) { tint ->
                SwetIcon(
                    icon = if (expanded) SwetIcons.ChevronUp else SwetIcons.ChevronDown,
                    tint = tint,
                    contentDescription = null,
                )
            }
        }
        if (expanded) {
            Row(
                horizontalArrangement = Arrangement.spacedBy(Space.half),
                verticalAlignment = Alignment.CenterVertically,
            ) {
                MORE_REACTION_OPTIONS.forEach { emoji -> ReactionEmoji(emoji, onEmojiSelected) }
            }
        }
    }
}

@Composable
private fun ReactionEmoji(emoji: String, onEmojiSelected: (String) -> Unit) {
    Text(
        text = emoji,
        fontSize = 24.sp,
        modifier = Modifier
            .clip(RoundedCornerShape(Radius.full))
            .swetPressable(
                onClick = { onEmojiSelected(emoji) },
                feedback = SwetPressFeedback.Scale,
            )
            .padding(Space.one),
    )
}
